export default "__VITE_ASSET__BtXUZGq9__"